import { dataCalendarCny } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCalendarCny = /*#__PURE__*/createIcon(dataCalendarCny)
export default IconCalendarCny
